import React, { useState, useEffect } from 'react';
import { CategoryService, LocalStorageService } from '../../../services';
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { DigitalVaultCategoriesView } from '../../views';

function DigitalVaultCategoriesAction(props) {
    const {
        toggleErrorRequesting,
        viewAsCards,
        setViewAsCards,
        breadcrumbItems,
        handleBreadcrumbClick,
        selectedCompany,
        setSelectedCategory,
    } = props;

    const url = process.env.REACT_APP_MIFIRMA_API;
    const localStorageService = new LocalStorageService();
    const categoryService = new CategoryService(url);
    const token = localStorageService.getLocalStorageItem("token").idToken;

    const [isLoading, setIsLoading] = useState(true);
    const [categories, setCategories] = useState([]);

    const loadCategories = async () => {
        setIsLoading(true);

        try {
            const companyId = selectedCompany ? selectedCompany.company.id : null;
            const response = await categoryService.getCategories(token, companyId);
            if (response.statusCode == 200 && response.data) {
                setCategories(response.data);
            } else {
                throw new Error(response.data.message || "Ocurrió un error obteniendo las categorías.")
            }
            setIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    useEffect(() => {
        loadCategories();
    }, [])

    return (
        <DigitalVaultCategoriesView
            {...props}
            loadCategories={loadCategories}
            isLoading={isLoading}
            viewAsCards={viewAsCards}
            setViewAsCards={setViewAsCards}
            breadcrumbItems={breadcrumbItems}
            handleBreadcrumbClick={handleBreadcrumbClick}
            selectedCompany={selectedCompany}
            categories={categories}
            setSelectedCategory={setSelectedCategory}

            localStorageService={localStorageService}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultCategoriesAction));